import {
  Component,
  DestroyRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TopNavBar } from '../top-nav-bar/top-nav-bar';
import { OpenCaseBar } from '../open-case-bar/open-case-bar';
import { Sidebar } from '../sidebar/sidebar';
import { AuthService } from '#services';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, TopNavBar, OpenCaseBar, Sidebar],
  templateUrl: './app-layout.html',
  styleUrl: './app-layout.scss',
})
export class AppLayout {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _destroyRef = inject(DestroyRef);
  private _sidebarOpen = signal(this.loadSidebarState());
  private _isMobile = signal(false);

  sidebarOpen = this._sidebarOpen.asReadonly();
  isMobile = this._isMobile.asReadonly();

  constructor() {
    this.checkMobile();

    this._authService.userDetails$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((userDetails) => {
        if (userDetails === null || this._router.url.startsWith('/403')) {
          return;
        }

        if (!userDetails.hasAccess) {
          const roles = this._authService.getRoles();
          const message = roles.length > 1
            ? 'More than one role has been assigned to your account. Please contact the administrator.'
            : 'Your account does not have any Centaur roles assigned. Please contact your administrator to request access.';
          this._router.navigate(['/403'], { state: { message } });
        }
      });
  }

  @HostListener('window:resize')
  checkMobile(): void {
    const mobile = window.innerWidth <= 768;
    this._isMobile.set(mobile);
    if (mobile) this._sidebarOpen.set(false);
  }

  toggleSidebar(): void {
    this._sidebarOpen.update((v) => !v);
    if (!this._isMobile()) {
      localStorage.setItem('centaur_sidebar_open', String(this._sidebarOpen()));
    }
  }

  closeOverlay(): void {
    if (this._isMobile()) this._sidebarOpen.set(false);
  }

  private loadSidebarState(): boolean {
    const stored = localStorage.getItem('centaur_sidebar_open');
    return stored === null ? true : stored === 'true';
  }
}
